import React from 'react';
import Stack from '../../v2BaseComponents/Stack';

export type ContainerOwnProps = {
    renderSearch: () => React.ReactNode;
    renderFilterButton?: () => React.ReactNode;
    renderFilterSummary?: () => React.ReactNode;
};

export type ContainerProps = ContainerOwnProps;

const Container: React.FC<ContainerProps> = (props) => {
    return (
        <Stack vertical space={1}>
            <Stack horizontal space={2.5} align="center" fullWidth>
                <Stack horizontal flex={1}>
                    {props.renderSearch()}
                </Stack>
                {props.renderFilterButton?.() || null}
            </Stack>
            <Stack horizontal justify={'flex-start'}>
                {props.renderFilterSummary?.() || null}
            </Stack>
        </Stack>
    );
};

export default React.memo(Container);
